<template>
  <q-btn
    v-if="isGranted('DELETE_USER', user)"
    icon="fa fa-times"
    title="Delete user"
    v-bind="$attrs"
    @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { User } from '@/type';
import openModal from '@/components/modal';
import DeleteUserModal from './DeleteUserModal.vue';

export default defineComponent({
  emits: ['deleted'],
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { user: _.cloneDeep(this.user) };
      openModal(DeleteUserModal, props).onOk((user: User) => {
        this.$emit('deleted', user);
      });
    },
    isGranted,
  },
});
</script>
